import * as z from "zod";

export const SHOPPER_AGENT_GUIDELINE_MAX_LENGTH = 500;

export const SHOPPER_AGENT_GUIDELINE_MAX_COUNT = 20;

export const ShopperAgentGuidelineTextSchema = z
  .string()
  .trim()
  .min(1)
  .max(SHOPPER_AGENT_GUIDELINE_MAX_LENGTH);

const ShopperAgentGuidelineSchema = z.object({
  merchantText: ShopperAgentGuidelineTextSchema,
  rule: z.string(),
  /** The yes/no question Jev answers about a draft; yes always means the draft breaks the guideline. */
  question: z.string(),
});

export type ShopperAgentGuideline = z.infer<typeof ShopperAgentGuidelineSchema>;
